
import React from 'react'
import styled from 'styled-components'
import { Input } from 'rsuite'
import { colors, fonts } from '../Styles/common-styles'

const SaveButton = styled.button`
  background: ${colors.purpleBright};
  font-weight: 600;
  font-size: ${fonts.normalSize};
  line-height: 18px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 11px 18px;
  &:hover {
    background: ${colors.purpleMain};
  }
`

const inputStyles = {
  marginTop: 32,
  marginLeft: 15
}

const textStyles = {
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '24px',
  color: colors.black
}

const Password = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '370px' }}>
      <div style={inputStyles}>
        <span style={textStyles}>Current password</span>
        <Input placeholder='Your current password' type='password' />
      </div>

      <div style={inputStyles}>
        <span style={textStyles}>New password</span>
        <Input placeholder='At least 8 characters long' type='password' />
      </div>

      <div style={inputStyles}>
        <span style={textStyles}>Repeat password</span>
        <Input placeholder='At least 8 characters long' type='password' />
      </div>

      <SaveButton style={{ margin: '44px 0 0 15px' }}>Save changes</SaveButton>
    </div>
  )
}

export default Password
